import { useState } from 'react';
function useBoolean(defaultValue) {
    var _a = useState(!!defaultValue), value = _a[0], setValue = _a[1];
    var setTrue = function () { return setValue(true); };
    var setFalse = function () { return setValue(false); };
    var toggle = function () { return setValue(function (x) { return !x; }); };
    return { value: value, setValue: setValue, setTrue: setTrue, setFalse: setFalse, toggle: toggle };
}
export default useBoolean;
//# sourceMappingURL=useBoolean.js.map